import React, { Component } from 'react';
import EWH from '../components/EWH';
import { useParams } from "react-router-dom";

function withParams(Component) {
  return props => <Component {...props} params={useParams()} />;
}


export class RegioneEuropee extends Component {
  render() {
    let { circoscrizione} = this.props.params;
    let { regione } = this.props.params;
    let repoFascione = "/elezioni/withub/electionday-2024/europee/fascione-italia.html";
    let repoDettaglio = "/elezioni/withub/electionday-2024/europee/" + circoscrizione + "/" + regione + "/dettaglio.html";
    return (
    <div className="App">
        <EWH id="ewh-fascione" repo={repoFascione} />
        <EWH id="ewh-dettaglio" repo={repoDettaglio} />
    </div>
    )
  }
}

export default withParams(RegioneEuropee)
